import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppConfig {
  /* BUSBOOKMARK API BASE URL */
  public baseURL = "https://www.busbookmark.jp/";
  public busAPIBaseURL = "https://stg.dev.busbookmark.jp/api/";
  // public baseURL = "https://fx.busbookmark.jp/";
  // public busAPIBaseURL = "https://fx.busbookmark.jp/api/";
  // public baseURL = "https://local.busbookmark.jp/";
  // public busAPIBaseURL = "https://local.busbookmark.jp/api/";
  public productionDomain = "busbookmark.jp";

  /* SERVER SIDE */
  public server = {
    timeZoneOffset: 9 /* (UTC +9) */,
  };

  /* PAYMENT */
  public payment = {
    gmo: {
      authID: "0000000001",
      merchantCode: "ab008993-00" /* AKA. SHOP CODE */,
      smsPassword:
        "CA5ACFCB7F03C89932FC31C274598F908BABB7D4F94F90786FDBBD97B51E72F9",
    },
  };

  /* RESERVATION */
  public reservation = {
    passengerSessionName: "cartUser",
    reservationDataSessionName: "reservationData",
    insuranceDataSessionName: "insuranceData",
    insuranceTokenSessionName: "insuranceToken",
    reservationCompleteDataSessionName: "reservationCompleteData",
    insurancePassengerData1SessionName: "insurancePassengerData1",
    paymentCalculationDataSessionName: "paymentCalculationData",
    couponDataName: "couponData",
    useCoupon: 1,
    defaultUserData: {
      sexMale: 1,
      sexFemale: 2,
    },
    insurancePrice: 500,
    insuranceChuBbMaxAge: 89,
    insuranceChuBbMaxDay: 13,
    zurichInsuranceRate: 0.0162 / 0.35,
    paymentType: {
      creditCard: 1,
      bank: 2,
      postpay: 4,
      paypay: 5,
      paidy: 6,
    },
    departureType: {
      day: 1,
      night: 2,
    },
    paymentStatus: {
      notPaid: 1,
      paid: 2,
      error: 9,
    },
    bookingStatus: {
      booking: 1,
      changed: 2,
      cancelled: 9,
    },
    priceType: {
      adult: 1,
      children: 2,
    },
    registerWithFacebook: 1,
    registerWithLine: 2,
    registerWithBooking: 3,
    registerWithBookingOn: 1,
    registerWithBookingOff: 0,
    withoutRegisterOn: 1,
    withoutRegisterOff: 0,
    useInsuranceOn: 1,
    useInsuranceOff: 0,

    searchPageLimits: 15,
    searchReceiptPageLimits: 15,
    paginationPageSegmentLimits: 5,

    receiptPriceLimit: 50000,

    passengerAgeLimit: {
      min: 6,
      max: 99,
      adultMin: 13,
      childrenMin: 6,
      childrenMax: 12,
    },

    planAgeLimit: {
      SNE: {
        min: 15,
      },
    },

    passengerBoarding: {
      boarding: 1,
      cancelled: 2,
    },

    passengerRepresentative: 1,

    errorCreditCardSessionName: "errorCreditCard",
    changeReservationDataSessionName: "changeReservation",

    refuncCharge: {
      paypay: 500,
      cvs: 770,
      paidy: 500,
    },
  };

  /* CART */
  public cart = {
    cartSessionName: "cart",
    serchSessionName: "serch",
  };

  /* PLAN */
  public plan = {
    viewedPlanSessionName: "viewedPlans",
    favouritePlanSessionName: "favouritePlans",
    filterSessionName: "planFilters",
    divisionDataSessionName: "divisionData",
    getStationSessionName: "getStation",
    bestPriceSessionName: "bestPriceData",
    acdCodeSessionName: "acdCode",
    referrerSessionName: "referrer",
    maxViewedPlans: 25,
    searchPageLimits: 10,
    mIcons: {
      /* FOR THE FUTURE USE */ "10001": "昼便",
    },
    sources: {
      keio: 2,
      kobo: 9,
    },
    keio: {
      passengerLimit: 12,
    },
  };

  /* SOCIAL LOGINS */
  public social = {
    facebook: {
      loginURL:
        "https://www.facebook.com/v4.0/dialog/oauth?client_id=505989640163220&redirect_uri=https://www.busbookmark.jp/&state=123213&response_type=token",
      postURL: "https://www.facebook.com/v4.0/dialog/oauth",
      clientID: "505989640163220",
      redirectUri: "https://www.busbookmark.jp/api/auth/loginWithFacebook",
      state: "123123",
      response_type: "code",
    },
    line: {
      clientID: "1600443433",
      clientSecret: "9ceb66929a12062563dfa610cf25cce5",
      grantType: "authorization_code",
      redirectUri: "https://www.busbookmark.jp/",
      postURL: "https://api.line.me/oauth2/v2.1/token",
      authorizeURL: "https://access.line.me/oauth2/v2.1/authorize",
      responseType: "code",
      state: "12345",
      scope: "openid profile",
    },
    google: {
      loginURL: "https://accounts.google.com/o/oauth2/auth",
      clientID:
        "470537554612-jsrh2anaf78357vbjeei8grsefe83kvm.apps.googleusercontent.com",
      scope: "openid email profile",
      responseType: "code",
      redirectUri: "https://www.busbookmark.jp/",
    },
    yahoo: {
      loginURL: "https://auth.login.yahoo.co.jp/yconnect/v2/authorization",
      responseType: "code",
      clientID: "dj00aiZpPW9QOWV1QldUZndpTSZzPWNvbnN1bWVyc2VjcmV0Jng9MjA-",
      scope: "openid profile email address",
      redirectUri: "https://www.busbookmark.jp/",
    },
    twitter: {
      loginURL: "https://www.busbookmark.jp/api/auth/loginWithTwitter",
    },
    instagram: {
      clientID: "1600443433",
      authorizeURL: "https://access.line.me/oauth2/v2.1/authorize",
      responseType: "code",
      scope: "openid profile",
    },
    list: [
      { type: 2, name: "LINE" },
      { type: 1, name: "Facebook" },
      { type: 3, name: "Google" },
      { type: 4, name: "Yahoo JP" },
    ],
  };

  /* EMBED CODES */
  public embedCode = {
    a8: {
      pid: "s00000012469001",
      pidTest: "s00000000062001",
    },
  };

  /* AUTHENTICATION */
  public auth = {
    loginSessionName: "bus_userData",
    currentURLSessionName: "bus_currentURL",
  };

  /* SITES */
  public site = {
    settingSessionName: "settings",
  };

  /* CACHE */
  public cache = {
    ttl: {
      cartItem: 240 * 60 * 1000 /* TIME TO LIVE IN MINUTE :: 240 MINUTES */,
      divisionData: 180 * 60 * 1000 /* TIME TO LIVE IN MINUTE :: 180 MINUTES */,
      bestPrice: 30 * 60 * 1000 /* TIME TO LIVE IN MINUTE :: 30 MINUTES */,
      common: 120 * 60 * 1000 /* TIME TO LIVE IN MINUTE :: 120 MINUTES */,
    },
  };

  /* LOCAL STORAGE */
  public localStoragePrefixName = "bus_ls_";
  public localStorageCachePrefixName = "bus_ls_cache_";
}
